import { useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Breadcrumb from "@/components/feature/Breadcrumb";
import VideoCard from "@/components/feature/VideoCard";
import EmptyState from "@/components/feature/EmptyState";
import { videos } from "@/mocks/videos";
import { useFavorites } from "@/hooks/useFavorites";

export default function FavoritesPage() {
  const { favorites, clear } = useFavorites();

  useEffect(() => {
    document.title = "我的收藏 - 91看片";
    window.scrollTo({ top: 0 });
  }, []);

  const items = useMemo(
    () => favorites.map((id) => videos.find((v) => v.id === id)).filter((v): v is (typeof videos)[number] => Boolean(v)),
    [favorites]
  );

  return (
    <SiteLayout>
      <div className="mx-auto max-w-[1400px] px-4 py-6 md:px-6 md:py-8">
        <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "我的收藏" }]} />

        <div className="mt-4 rounded-lg border border-background-200 bg-background-100 p-5 md:p-7">
          <div className="flex flex-wrap items-center justify-between gap-3">
            <div>
              <h1 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">我的收藏</h1>
              <p className="mt-2 text-sm text-foreground-600">
                收藏状态保存在浏览器本地，共 <span className="font-bold text-accent-600">{items.length}</span> 部影视作品。
              </p>
            </div>
            {items.length > 0 && (
              <button
                type="button"
                onClick={clear}
                className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-accent-400 hover:text-accent-600"
              >
                <i className="ri-delete-bin-6-line" />
                清空收藏
              </button>
            )}
          </div>
        </div>

        <div className="mt-6">
          {items.length === 0 ? (
            <EmptyState
              icon="ri-heart-3-line"
              title="收藏夹还是空的"
              description="浏览影视详情页时点击“收藏”，就能把喜欢的作品保存到这里，方便下次快速找到。"
            >
              <Link
                to="/category/movie"
                className="cursor-pointer rounded-md bg-accent-500 px-4 py-2 text-sm font-semibold text-background-50"
              >
                去逛逛电影频道
              </Link>
            </EmptyState>
          ) : (
            <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5">
              {items.map((item) => (
                <VideoCard key={item.id} item={item} showFavorite />
              ))}
            </div>
          )}
        </div>
      </div>
    </SiteLayout>
  );
}